import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
import { z } from 'zod';
const DEFAULT_PHONE_NUMBER_COUNTRY = 'CH';
export const normalizePhoneNumber = (value) => {
    const parsed = parsePhoneNumberFromString(value, DEFAULT_PHONE_NUMBER_COUNTRY);
    return parsed?.isValid() ? parsed.number : undefined;
};
export const phoneNumberSchema = (error = 'Invalid phone number') => z.string({ error }).transform((value, ctx) => {
    const normalized = normalizePhoneNumber(value);
    if (normalized === undefined) {
        ctx.addIssue({ code: 'custom', message: error });
        return z.NEVER;
    }
    return normalized;
});
export const optionalPhoneNumberSchema = phoneNumberSchema().or(z.literal('')).optional();
